<template>
    <form method="post"
          :action="action"
          @submit.prevent="onSubmit"
          @keydown="form.errors.clear($event.target.name)">

        <div class="form-group my-input-item">
            <input type="text"
                   name="name"
                   class="form-control my-input-form my-input-form-grey"
                   :placeholder="Lang.get('common.name')"
                   v-model="form.name"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('name')"
                  v-text="form.errors.get('name')">
            </span>
        </div>

        <div class="form-group my-input-item">
            <input type="text"
                   name="phone"
                   class="form-control mobilephone-input-mask my-input-form my-input-form-grey"
                   :placeholder="Lang.get('common.phone')"
                   v-model="form.phone"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('phone')"
                  v-text="form.errors.get('phone')">
            </span>
        </div>

        <div class="form-group">
            <textarea name="message"
                      :placeholder="Lang.get('common.message')"
                      class="form-control"
                      v-model="form.message">{{ form.message }}</textarea>
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('message')"
                  v-text="form.errors.get('message')">
            </span>
        </div>

      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" value="" id="agreeCheck" v-model="agree">
        <label class="form-check-label" for="agreeCheck">
          Я даю своё согласие на обработку персональных данных в соответствии с
          <a href="/politika-konfidentsialnosti" target="_blank" class="my-link"> Политикой конфиденциальности </a>
          и <a href="/soglasie-na-obrabotku-personalnykh-dannykh" target="_blank" class="my-link">Согласием на обработку персональных данных</a>.
        </label>
      </div>

      <input type="text"
             name="checkBot"
             v-model="checkBot"
      >

        <input class="my-button"
               type="submit"
               :disabled="isDisabled"
               :value="Lang.get('common.send')">
        <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
    </form>
</template>

<script>
  import WidgetLoading from '../elements/WidgetLoading';

  export default {
    name: "form-contacts",
    components: {
      WidgetLoading,
    },
    data() {
      return {
        form: new Form({
          name: '',
          phone: '',
          message: '',
          type: 'contacts',
          url: location,
          lang: siteLang,
        }),
        action: '/callback',
        agree: true,
        checkBot: '',
        Lang,
      }
    },

    computed: {
      isDisabled() {
        return !this.agree || this.form.loading || this.form.errors.any();
      }
    },

    methods: {
      onSubmit() {
        if(this.checkBot === '') {
          this.form.submit(this.$el.method, this.$el.action).then(res => {
            document.querySelector('#contacts-form').innerHTML = "<span class='success-sent-text text-center'>" + res +"</span>";
          }).catch(error => console.log(error));
        }
      },
    },
    mounted() {
      helpers.setInputMask('mobilephone');
    }
  }
</script>
